import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import Sizes from '../definitions/Sizes';
import Colours from '../definitions/Colours';
import { GLAMAZON_STYLES, VARIANTS } from '../styles/AnchorStyles';
import Typography from '../definitions/Typography';
import formatPhoneNumber from '../functions/formatPhoneNumber';
import IconChooser from './IconChooser';


function PhoneNumberBlock({
    phoneNumber,
    label,
    showIcon = false,
    isPadded = true,
    className,
    ...otherProps
}) {
    const sanitizedPhoneNumber = formatPhoneNumber(phoneNumber);

    return (
        <Container
            {...otherProps}
            className={classNames(className, {
                'rh-py-0_75 rh-px-2 rh-my-1': isPadded,
            })}
        >
            <span className="flex-child label-container rh-text-align-center leading-l rh-m-0 rh-text-s weight-regular">
                {/* Note we don't use a real <label> element here because an Anchor is not a form element. Chrome
                complains when we use <label>, whether it's associated with the anchor or not. */}
                <span className="label">
                    {label}
                </span>

                <If condition={showIcon}>
                    <IconChooser
                        iconKey="phone"
                        size="M"
                        outlineWidth="0"
                        stroke={Colours.BLACKBERRY}
                    />
                </If>
            </span>

            <Anchor
                className="flex-child number leading-l rh-text-align-center rh-m-0"
                href={`tel:${sanitizedPhoneNumber}`}
                variant={VARIANTS.DARK}
                data-name="PhoneNumberBlock-phoneNumber"
            >
                {sanitizedPhoneNumber}
            </Anchor>
        </Container>
    );
}

PhoneNumberBlock.propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    showIcon: PropTypes.bool,
    isPadded: PropTypes.bool,
    className: PropTypes.string,
};

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    column-gap: ${Sizes.SPACING.QUARTER};

    > .flex-child {
        flex: auto 1 0;
    }

    background-color: transparent;

    > .label-container {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;

        max-width: 100%;

        > .label {
            color: ${Colours.BLACKBERRY};
        }
    }

    > .number {
        display: block;
    }
`;

// TODO: Can we just style <a> globally? Possibly. See rh-anchor-animation-base mixin?
const Anchor = styled.a`
    ${GLAMAZON_STYLES};

    /* These properties are defined in GLAMAZON_STYLES and therefore can't be written
    using rh-* utility classes, which are lower specificity */
    font-size: ${Sizes.FONTS.XS};
    font-weight: ${Typography.WEIGHTS.MEDIUM};
`;

export default PhoneNumberBlock;
